// contexts/AuthContext.ts
import { createContext, useContext } from 'react';
import type { AuthAction, AuthState, AuthUser } from '@/types/auth';

export const initialAuthState: AuthState = {
    user: null,
    role: null,
    isAuth: false,
    loading: true,
    error: null,
};

export const authReducer = (state: AuthState, action: AuthAction): AuthState => {
    switch (action.type) {
        case 'LOGIN':
            return { ...state, ...action.payload, isAuth: true, loading: false, error: null };
        case 'LOGOUT':
            return { ...initialAuthState, loading: false };
        case 'SET_LOADING':
            return { ...state, loading: action.payload };
        case 'AUTH_ERROR':
            return { ...state, error: action.payload, loading: false };
        default:
            return state;
    }
};

export interface AuthContextValue {
    authState: AuthState;
    login: (email: string, password: string) => Promise<{ status: string; error?: string }>;
    logout: () => Promise<void>;
    refreshToken: () => Promise<boolean>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export const useAuth = (): AuthContextValue => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
    return ctx;
};

// Re-export for convenience
export type { AuthUser };
